import { render, staticRenderFns } from "./EditAccountDetailsForm.vue?vue&type=template&id=2b86c102&"
import script from "./EditAccountDetailsForm.vue?vue&type=script&lang=js&"
export * from "./EditAccountDetailsForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports